import { create } from 'zustand';

// Stockage en mémoire uniquement (jamais persisté sur disque) du mot de passe
// en clair, le temps de proposer l'activation de la biométrie sur l'écran
// d'accueil juste après la connexion. Vidé dès que l'utilisateur répond,
// et perdu automatiquement au redémarrage de l'application.
interface BiometricEnrollmentStore {
  pendingCredentials: { username: string; password: string } | null;
  setPendingCredentials: (credentials: { username: string; password: string }) => void;
  clearPendingCredentials: () => void;
}

export const useBiometricEnrollmentStore = create<BiometricEnrollmentStore>((set) => ({
  pendingCredentials: null,
  setPendingCredentials: (credentials) => set({ pendingCredentials: credentials }),
  clearPendingCredentials: () => set({ pendingCredentials: null }),
}));
